module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "color": "primary",
      "dark": ""
    },
    slot: "activator"
  }, [_vm._v("\n    Bulk Import Vehicles\n  ")]), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "color": "primary"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-container', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Bulk Add Vehicles")])]), _vm._v(" "), _c('v-card-text', [_c('v-autocomplete', {
    attrs: {
      "items": _vm.customerList,
      "loading": _vm.gettingCustomers,
      "label": "Select a Customer",
      "item-text": "name",
      "item-value": "key",
      "required": "",
      "rules": [function (v) { return !!v || 'Customer is required'; }],
      "disabled": _vm.customerFixed
    },
    model: {
      value: (_vm.Customer),
      callback: function($$v) {
        _vm.Customer = $$v
      },
      expression: "Customer"
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "label": "Site",
      "items": _vm.sites,
      "item-text": "name",
      "item-value": "key",
      "clearable": "",
      "append-outer-icon": "mdi-plus"
    },
    on: {
      "click:append-outer": function($event) {
        _vm.siteDialog = true
      }
    },
    model: {
      value: (_vm.Site),
      callback: function($$v) {
        _vm.Site = $$v
      },
      expression: "Site"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "hide-overlay": "",
      "transition": "dialog-bottom-transition"
    },
    model: {
      value: (_vm.siteDialog),
      callback: function($$v) {
        _vm.siteDialog = $$v
      },
      expression: "siteDialog"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.siteDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Sites")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.siteDialog = false
      }
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('v-layout', [(_vm.siteDialog) ? _c('sites-view') : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "label": "Excel Data Input"
    },
    model: {
      value: (_vm.excelInput),
      callback: function($$v) {
        _vm.excelInput = $$v
      },
      expression: "excelInput"
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Input includes header row"
    },
    model: {
      value: (_vm.includeHeaders),
      callback: function($$v) {
        _vm.includeHeaders = $$v
      },
      expression: "includeHeaders"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.Site || !_vm.Customer || !_vm.excelInput || _vm.saving,
      "loading": _vm.processing
    },
    on: {
      "click": _vm.processRawData
    }
  }, [_vm._v("Process Data")])], 1), _vm._v(" "), (_vm.dataProcessed) ? _c('div', {
    staticClass: "mt-5"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Output Data")]), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "pagination": _vm.pagination,
      "hide-actions": "",
      "items": _vm.processedData,
      "headers": _vm.headers
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          class: {
            'red': props.item.duplicate
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.VehicleReg))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.FleetNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.Make))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.Model))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.Year))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.Type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.VUPartNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.FuelTankSize))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.AdditionalInfo))])])]
      }
    }], null, false, 3149968582)
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-checkbox', {
    staticClass: "shrink",
    attrs: {
      "label": "I confirm the above output is correct"
    },
    model: {
      value: (_vm.dataLooksGood),
      callback: function($$v) {
        _vm.dataLooksGood = $$v
      },
      expression: "dataLooksGood"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.dataLooksGood || _vm.containsDups,
      "loading": _vm.saving
    },
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v("Save Vehicles")])], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d4425e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/BulkAddVehicleDialog.vue
// module id = 758
// module chunks = 1